// Capitalise a given word
// Also capitalise hyphentated words
export const capitaliseWord = word =>
  word ? (word[0].toUpperCase() + word.slice(1)).replace(/(^|[\s-])\S/g, match => match.toUpperCase()) : '';
